import type { ReactNode } from 'react';

export const symbol_sports_gymnastics: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m489-108-19-370-149-52H70q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-590 70-590h213l253-181q10-7 20.96-5.53 10.96 1.46 19 10.26Q584-756 583-743q-1 13-12 21l-123 88 97 34 320-188q8-5 17.92-2.87 9.92 2.13 18 11.35 8.08 8.52 6.55 19.86Q905.94-748.32 896-741L574-507l-22 399q-.8 11.79-10.4 19.89Q532-80 518.15-80q-11.66 0-20.04-8.11-8.38-8.1-9.11-19.89ZM240.08-647q-30.08 0-51.58-21.42t-21.5-51.5q0-30.08 21.42-51.58t51.5-21.5q30.08 0 51.58 21.42t21.5 51.5q0 30.08-21.42 51.58t-51.5 21.5Z"
		/>
	</svg>
);
